// Daily Giveaway payload refresh (ENG-2205). The initial pass data already
// carries the `giveaway` section; this endpoint re-fetches it after an entry
// or a period roll without reloading the whole pass.

export default $axios => ({
  get(partnerUserId, dealId) {
    return $axios.get(`/api/partnerUser/${partnerUserId}/giveaway/${dealId}`);
  }
});
